import api from '../../api';

export const sendContact = (slug, params = {}) => api.post(`/contact_messages/${slug}`, params);
